import { Directive } from '@angular/core';
import { BrnSheetTrigger } from '@spartan-ng/brain/sheet';

@Directive({
    host: { 'data-slot': 'sheet-trigger' },
    hostDirectives: [{ directive: BrnSheetTrigger, inputs: ['id', 'side', 'type'] }],
    selector: 'button[hlmSheetTrigger]',
})
export class HlmSheetTrigger {}
